/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {

//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the 
//   // scroll locking code knows what element should maintain scoll. 
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// })();



/*

// This is for when we want to show delivery date in cart drawer

const extractDate = (text) => {
  const dateRegex = /\b[a-zæøå]+\s+d\.\s+\d{1,2}\.\d{1,2}\b/i;
  const match = text.match(dateRegex);
  return match ? match[0] : null;
}

const checkCartPreorder = (cart) => {
  const cloneAttribute = 'data-clone'  
  const hasPreorderItem = cart.items.find(item => item.properties[window.theme.strings.preOrdering]);
  const cartDeliveryWrapper = document.querySelector('.cart-drawer__delivery');

  const getClone = () => {
    const createClone = () => {
      const clone = cartDeliveryWrapper.cloneNode(true);
      clone.setAttribute(cloneAttribute, true)
      cartDeliveryWrapper.insertAdjacentElement('afterend', clone);

      return clone;
    }
    return document.querySelector(`.cart-drawer__delivery[${cloneAttribute}]`) ?? createClone();
  }

  const clone = getClone();

  if (hasPreorderItem) {
    const textElement = clone.querySelector('p');
    textElement.textContent = `${window.theme.strings.preOrdering}: ${window.theme.strings.expectedDelivery} ${extractDate(clone.textContent)}`;

    clone.hidden = false;
    cartDeliveryWrapper.hidden = true;
  } else {
    clone.hidden = true;
    cartDeliveryWrapper.hidden = false;
  }
}

document.addEventListener('theme:cart:change', (event) => {
  const cart = event.detail.cart;
  if (cart) {
    checkCartPreorder(cart);
  }
});

document.addEventListener('theme:cart:init', (e) => {
  const cart = e.detail.cart;
  if (cart) {
    checkCartPreorder(cart);
  }
});

*/

const preOrderInputElement = document.querySelector('[data-product-preorder]');
if (preOrderInputElement) {
  const wrapper = document.querySelector('[data-product-form-wrapper] .delivery-widget__manual');

  if (wrapper) {
    const updatePreorderInputElement = () => {
      preOrderInputElement.value = wrapper.textContent.replace('●','').trim();
    }
  
    if (wrapper.children.length == 0) {
      const onWrapperPopulated = () => {
        updatePreorderInputElement();
      };
      
      const wrapperCheckInterval = setInterval(() => {
        if (wrapper) {
          clearInterval(wrapperCheckInterval); 
          const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                onWrapperPopulated(wrapper);
                observer.disconnect();
                return;
              }
            }
          });
  
          observer.observe(wrapper, {
            childList: true,
          });
        }
      }, 10);
    } else {
      updatePreorderInputElement();
    }
  }
}

const recipeSearchTrigger = document.querySelector('gtc-trigger[aria-controls="recipe-search"]');
if (recipeSearchTrigger) {
  recipeSearchTrigger.addEventListener('click', () => {
    setTimeout(() => {
      const recipeSearchInput = document.querySelector('[data-recipe-search-input]');
      recipeSearchInput.focus();
    }, 10);
  })
}

const mainSearchBar = document.querySelector('[data-main-search]');
if (mainSearchBar) {
  mainSearchBar.addEventListener('click', () => {
    const toggle = document.querySelector('[data-popdown-toggle="search-popdown"]');
    toggle.click();
  });
}

const playLazyVideo = (video) => {
  const isAutoplayingLazyVideo = video.tagName === 'VIDEO' && video.autoplay;

  if (!isAutoplayingLazyVideo) {
    return;
  }

  window.setTimeout(() => {
    video.play().catch(() => {});
  }, 0);
};

document.addEventListener('lazybeforeunveil', (event) => {
  playLazyVideo(event.target);
});

document.querySelectorAll('video.lazyloading, video.lazyloaded').forEach((video) => {
  playLazyVideo(video);
});

document.addEventListener('DOMContentLoaded', function() {
  const stickyButtons = document.querySelectorAll('[data-sticky-button]');

  if (stickyButtons.length === 0) {
    return;
  }

  stickyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const formId = button.getAttribute('form');
      const productAddToCartButton = document.querySelector(`button[form="${formId}"][data-add-to-cart]`);
      if (productAddToCartButton) {
        productAddToCartButton.click();
      } else {
        console.error('No product add to cart button found', button);
      }
    });
  });
});
